import { api, isDefined, isEnumMember } from 'common';

import { BlockType } from '../../../../types';
import { llmPromptBlockDefaultConfig } from '../../Llm/Shared/constants';
import { sharedRestBlockDefaultConfig } from '../../Rest/Shared/constants';
import { getScriptedFlowBlockDefaultConfig } from '../../ScriptedFlow/constants';
import { getSubFlowBlockDefaultConfig } from '../../SubFlow/v1/constants';

const iteratorBlockDefaultConfigOptions: Partial<
  Record<api.FlowDefinition.BlockType, api.FlowDefinition.FlowBlock['config']>
> = {
  [BlockType.LlmPrompt]: llmPromptBlockDefaultConfig,
  [BlockType.ScriptedFlow]: getScriptedFlowBlockDefaultConfig(),
  [BlockType.Rest]: sharedRestBlockDefaultConfig,
  [BlockType.SubFlowV1]: getSubFlowBlockDefaultConfig(),
};

export function getActionBlockConfig(action: string): api.FlowDefinition.FlowBlock['config'] {
  if (!isEnumMember(api.FlowDefinition.BlockType, action)) {
    throw new Error(`Action ${action} is not a valid action block type`);
  }

  const config = iteratorBlockDefaultConfigOptions[action];
  if (!isDefined(config)) {
    throw new Error(`Action ${action} is a valid action block type but is not supported`);
  }

  return config;
}
